<template>
    <div>
        <div style="margin: 3px 0px 3px 0px;padding: 3px;background: white">
            <el-row style="display: flex">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-folder-add" circle @click="add" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="批量删除" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-delete-solid" circle @click="ifBatchDel()" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-refresh-right" circle @click="reflash" type="success"></el-button>
                </el-tooltip>
            </el-row>
            <el-row>
                <el-input v-model="queryKey" type="text"
                          @click.native.prevent="getView"
                          @keyup.enter.native="getView"
                          suffix-icon="el-icon-search"
                          size="medium" style="width:200px;margin-left: 8px"></el-input>
                <el-tooltip class="item" effect="dark" content="查询" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-search" circle @click="getView"></el-button>
                </el-tooltip>
            </el-row>
        </div>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productname" label="品名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productmodel" label="型号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productspecs" label="规格"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg1" label="产品图片1">
                <template scope="scope">
                    <!--<img :src="expurl(scope.row.productimg1)">-->
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg1)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg2" label="产品图片2">
                <template scope="scope">
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg2)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg3" label="产品图片3">
                <template scope="scope">
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg3)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg4" label="产品图片4">
                <template scope="scope">
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg4)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="retailprice" label="零售价" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="provincialprice" label="省代价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cityprice" label="市代价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="bprice" label="B类价格" align="right"></el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click.native.prevent="confirmdel(scope.row)" type="text" size="mini">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="isShowEdit" width="80%" :close-on-click-modal="false">
            <el-row style="margin-top: 20px">
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="8rem" label-position="left" size="small">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="品名">
                                    <el-input v-model="dataDetail.productname" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="型号">
                                    <el-input v-model="dataDetail.productmodel" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="规格">
                                    <el-input v-model="dataDetail.productspecs" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="零售价">
                                    <el-input v-model="dataDetail.retailprice" type="number" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="省代价格">
                                    <el-input v-model="dataDetail.provincialprice" type="number" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="市代价格">
                                    <el-input v-model="dataDetail.cityprice" type="number" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="B类价格">
                                    <el-input v-model="dataDetail.bprice" type="number" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="图1">
                                    <el-upload
                                            :action="' '"
                                            list-type="picture-card"
                                            :on-preview="handlePictureCardPreview1"
                                            :on-remove="handleRemove1"
                                            :on-change="fileChange1"
                                            :auto-upload="false"
                                            :file-list="fileList1"
                                            :limit="1"
                                            >
                                    <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <el-dialog :visible.sync="Visible1">
                                        <el-image :src="ImageUrl1" alt=""></el-image>
                                    </el-dialog>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="图2">
                                    <el-upload
                                            :action="' '"
                                            list-type="picture-card"
                                            :on-preview="handlePictureCardPreview2"
                                            :on-remove="handleRemove2"
                                            :on-change="fileChange2"
                                            :auto-upload="false"
                                            :file-list="fileList2"
                                            :limit="1"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <el-dialog :visible.sync="Visible2">
                                        <el-image :src="ImageUrl2" alt=""></el-image>
                                    </el-dialog>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="图3">
                                    <el-upload
                                            :action="' '"
                                            list-type="picture-card"
                                            :on-preview="handlePictureCardPreview3"
                                            :on-remove="handleRemove3"
                                            :on-change="fileChange3"
                                            :auto-upload="false"
                                            :file-list="fileList3"
                                            :limit="1"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <el-dialog :visible.sync="Visible3">
                                        <el-image :src="ImageUrl3" alt=""></el-image>
                                    </el-dialog>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="图4">
                                    <el-upload
                                            :action="' '"
                                            list-type="picture-card"
                                            :on-preview="handlePictureCardPreview4"
                                            :on-remove="handleRemove4"
                                            :on-change="fileChange4"
                                            :auto-upload="false"
                                            :file-list="fileList4"
                                            :limit="1"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <el-dialog :visible.sync="Visible4">
                                        <el-image :src="ImageUrl4" alt=""></el-image>
                                    </el-dialog>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false">关闭</el-button>
				<el-button type="primary" @click="onSubmit" v-preventReClick>保存</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            return {
                dataSet: [], // 主表数据
                dataDetail: {},
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                user: "",
                usercode: "",
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 250, // 主表高度
                queryKey: "",
                SortList: [],
                ScreenList: [],
                isShowEdit: false, // 是否显示编辑页面

                ImageUrl1: '',
                file1: null,
                fileList1:[],
                Visible1: false,
                ImageUrl2: '',
                file2: null,
                fileList2:[],
                Visible2: false,
                ImageUrl3: '',
                file3: null,
                fileList3:[],
                Visible3: false,
                ImageUrl4: '',
                file4: null,
                fileList4:[],
                Visible4: false,
                selectData: [] //多选
            };
        },
        mounted: function () {
            let that = this
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username
            that.usercode = that.userData.Login_Code
            that.getView()
        },
        methods: {
            handlePictureCardPreview1(file) {
                let that = this;
                that.ImageUrl1 = file.url;
                that.Visible1 = true
            },
            handleRemove1(file, fileList) {
                let that = this;
                that.file1 = null
                that.ImageUrl1 = "";
                that.dataDetail.productimg1 = ""
            },
            fileChange1(file, fileList) {
                let that = this;
                that.file1 = file.raw;
            },
            handlePictureCardPreview2(file) {
                let that = this;
                that.ImageUrl2 = file.url;
                that.Visible2 = true
            },
            handleRemove2(file, fileList) {
                let that = this;
                that.file2 = null
                that.ImageUrl2 = "";
                that.dataDetail.productimg2 = ""
            },
            fileChange2(file, fileList) {
                let that = this;
                that.file2 = file.raw;
            },
            handlePictureCardPreview3(file) {
                let that = this;
                that.ImageUrl3 = file.url;
                that.Visible3 = true
            },
            handleRemove3(file, fileList) {
                let that = this;
                that.file3 = null
                that.ImageUrl3 = "";
                that.dataDetail.productimg3 = ""
            },
            fileChange3(file, fileList) {
                let that = this;
                that.file3 = file.raw;
            },
            handlePictureCardPreview4(file) {
                let that = this;
                that.ImageUrl4 = file.url;
                that.Visible4 = true
            },
            handleRemove4(file, fileList) {
                let that = this;
                that.file4 = null
                that.ImageUrl4 = "";
                that.dataDetail.productimg4 = ""
            },
            fileChange4(file, fileList) {
                let that = this;
                that.file4 = file.raw;
            },
            uploadFile(file, iid, type) {
                let that = this;
                let formData = new FormData(); //formdata格式
                formData.append('file', file);
                formData.append('iid', iid)
                formData.append('type', type)
                that.$http.urlpost('/SysProduct/UploadFile', formData, function (res) {
                    if (res.Success == 1) {
                        that.getView()
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            reflash() {
                let that = this
                that.queryKey = ""
                that.getView()
            },
            getView() {
                let that = this
                that.loading = true
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    ScreenList: that.ScreenList
                };
                that.$http.urlpost('/SysProduct/View', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            editInfo(row){
                let that = this
                that.isShowEdit = true
                that.isAdd = false;
                that.dataDetail = row
                that.file1 = null
                that.file2 = null
                that.file3 = null
                that.file4 = null
                if(that.dataDetail.productimg1 != ""){
                    that.ImageUrl1 = Common.Url + 'uploads/' + that.dataDetail.productimg1
                    that.fileList1 = [{
                        name: "",
                        url: that.ImageUrl1
                    }]
                } else {
                    that.ImageUrl1 = ""
                    that.fileList1 = []
                }
                if(that.dataDetail.productimg2 != ""){
                    that.ImageUrl2 = Common.Url + 'uploads/' + that.dataDetail.productimg2
                    that.fileList2 = [{
                        name: "",
                        url: that.ImageUrl2
                    }]
                } else {
                    that.ImageUrl2 = ""
                    that.fileList2 = []
                }
                if(that.dataDetail.productimg3 != ""){
                    that.ImageUrl3 = Common.Url + 'uploads/' + that.dataDetail.productimg3
                    that.fileList3 = [{
                        name: "",
                        url: that.ImageUrl3
                    }]
                } else {
                    that.ImageUrl3 = ""
                    that.fileList3 = []
                }
                if(that.dataDetail.productimg4 != ""){
                    that.ImageUrl4 = Common.Url + 'uploads/' + that.dataDetail.productimg4
                    that.fileList4 = [{
                        name: "",
                        url: that.ImageUrl4
                    }]
                } else {
                    that.ImageUrl4 = ""
                    that.fileList4 = []
                }
                that.isShowEdit = true
            },
            onSubmit() {
                let that = this
                let datetime = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()).toString()
                that.dataDetail.modifypersoncode = that.usercode
                that.dataDetail.modifypersonname = that.user
                that.dataDetail.modifytime = datetime
                let parm = that.dataDetail
                that.$http.urlpost('/SysProduct/Edit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowEdit = false
                        let iid = res.Key
                        if(that.file1 != null){
                            that.uploadFile(that.file1,iid,1)
                        }
                        if(that.file2 != null){
                            that.uploadFile(that.file2,iid,2)
                        }
                        if(that.file3 != null){
                            that.uploadFile(that.file3,iid,3)
                        }
                        if(that.file4 != null){
                            that.uploadFile(that.file4,iid,4)
                        }
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            add(){
                let that = this
                that.isAdd = true;
                let datetime = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()).toString()
                that.dataDetail = {
                    iid: "",
                    productname: "",
                    productmodel: "",
                    productspecs: "",
                    productimg1: "",
                    productimg2: "",
                    productimg3: "",
                    productimg4: "",
                    retailprice: 0,
                    provincialprice: 0,
                    cityprice: 0,
                    bprice: 0,
                    industry: "",
                    createpersoncode: that.usercode,
                    createpersonname: that.user,
                    createtime: datetime,
                    modifypersoncode: that.usercode,
                    modifypersonname: that.user,
                    modifytime: datetime,
                    remark: "",
                    status: ""
                }
                that.ImageUrl1= '',
                that.file1 = null
                that.fileList1 = []
                that.Visible1 = false
                that.ImageUrl2 = ''
                that.file2 = null
                that.fileList2 = []
                that.Visible2 = false
                that.ImageUrl3 = ''
                that.file3 = null
                that.fileList3 = []
                that.Visible3 = false
                that.ImageUrl4 = ''
                that.file4 = null
                that.fileList4 = []
                that.Visible4 = false
                that.isShowEdit = true
            },
            confirmdel(row){
                let that = this
                that.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.del(row);
                    })
                    .catch(() => {});
            },
            del(row) {
                let that = this
                let parm ={
                    iid: row.iid,
                    modifytime: row.modifytime,
                    createpersonname: that.user
                }
                that.$http.urlpost('/SysProduct/Delete', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            expurl(value){
                return Common.Url+'uploads/'+value
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i].iid);
                }
            },
            //批量删除
            ifBatchDel(){
                let that = this
                that.$confirm('是否批量删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.batchDel();
                    })
                    .catch(() => {});
            },
            batchDel(){
                let that = this
                let iids = Common.methods.arrToStr(that.selectData)
                let parm ={
                    iid: iids,
                    createpersonname: that.user
                }
                that.$http.urlpost('/SysProduct/Delete', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
</style>
